
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/buscador-programa/buscador-programa.module').then(m => m.BuscadorProgramaModule)
  },
  {
    path: ':id/entidad/:idUniversidad',
    loadChildren: () => import('./pages/informacion-programa/informacion-programa.module').then(m => m.InformacionProgramaModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProgramasRoutingModule { }
